import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IPortfolioSheetData } from '@/modules/catalog/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const fetchCreatePortfolio = inject('fetchCreatePortfolio', () => ({}));

const portfolioSheetData = inject(
  'portfolioSheetData'
) as Ref<IPortfolioSheetData>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const title = computed(() => {
  return `R$ ${amountFormatted.value}`;
});

function onClick() {
  fetchCreatePortfolio();
}

return { __sfc: true,fetchCreatePortfolio, portfolioSheetData, amountFormatted, title, onClick, HeadingDisplay, ListDisplay, ButtonContainer, ButtonPrimary }
}

})